export default __webpack_public_path__ + "static/MediaContentSix-6d278c10d08ed698e53b2975a1e67b6b.webp";